import { ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import { MouseEvent, KeyboardEvent, useState } from "react";

import { withForm } from "components/Forms/AppForm";

import initialPineFilters from "../../ProductsInEvalTable/schemas/initialPineFilter";
import progressPointLabels from "../data/progressPoints.json";

type ProgressPointKey = keyof typeof progressPointLabels;
const progressPoints = Object.keys(
  progressPointLabels,
).sort() as ProgressPointKey[];

const ProgressPointSelect = withForm({
  defaultValues: initialPineFilters,
  render: function Render({ form }) {
    const [selectedPoint, setSelectedPoint] = useState("1");
    const [selectedType, setSelectedType] = useState("estimate");

    const handlePointChange = (_e: MouseEvent<HTMLElement>, point: string) => {
      if (!point) return;

      setSelectedPoint(point);
      const field = `pp_${point}_${selectedType}`;
      form.setFieldValue("dynamicDate.field", field);
    };

    const handleStatusChange = (_e: MouseEvent<HTMLElement>, type: string) => {
      if (!type) return;

      setSelectedType(type);
      const field = `pp_${selectedPoint}_${type}`;
      form.setFieldValue("dynamicDate.field", field);
    };

    const handleSubmit = (e: KeyboardEvent) => {
      if (e.key === "Enter") form.handleSubmit();
    };

    return (
      <>
        {/* Progress Points */}
        <Typography
          variant="caption"
          textAlign="center"
          display="block"
          fontStyle="italic"
          color="secondary"
          mb={0.5}
          mt={-0.5}
        >
          {progressPointLabels[selectedPoint as ProgressPointKey]}
        </Typography>
        <ToggleButtonGroup
          exclusive
          value={selectedPoint}
          onChange={handlePointChange}
          size="small"
          fullWidth
          onKeyDown={handleSubmit}
        >
          {progressPoints.map((pp) => (
            <ToggleButton value={pp} key={pp}>
              {pp}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>

        {/* Types */}
        <ToggleButtonGroup
          exclusive
          value={selectedType}
          onChange={handleStatusChange}
          fullWidth
          sx={{ my: 1 }}
          onKeyDown={handleSubmit}
        >
          <ToggleButton value="estimate" size="small">
            Estimated
          </ToggleButton>
          <ToggleButton value="complete" size="small">
            Completed
          </ToggleButton>
        </ToggleButtonGroup>
      </>
    );
  },
});

export default ProgressPointSelect;
